import { useModals } from "@/features/modals/hooks";
import { type WidgetSettingsDefinition } from "@repo/api";
import { ListViewItem, warehouseIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { useOrderedCustomerMeetingPoints } from "@repo/ui";

export const StoreSettingsControl = ({
  settingDefinition,
  setting,
  setSetting,
}: {
  settingDefinition: WidgetSettingsDefinition;
  setting: Record<string, any>;
  setSetting: (newSetting: Record<string, object>) => void;
}) => {
  const { data: customerMeetingPoints } = useOrderedCustomerMeetingPoints();
  const { pushModal } = useModals();

  const value = setting[settingDefinition.id];
  const selectedCmp = customerMeetingPoints.find(([cmp]) => cmp === value);

  return (
    <ListViewItem
      control="navigational"
      title={t("label.cmp")}
      description={selectedCmp ? selectedCmp[1] : undefined}
      onClick={() => {
        pushModal({
          type: "SELECT_CMP",
          selectedCmp: value,
          onSelect: (cmp) => {
            setSetting({ ...setting, [settingDefinition.id]: cmp });
          },
        });
      }}
      leadingIcon={warehouseIcon}
    />
  );
};
